export interface GraphData {
  results: Array<{
    columns: string[]
    data: Array<{
      graph: {
        nodes: Node[]
        relationships: Relationship[]
      }
    }>
  }>
  errors: any[]
}

export interface Node {
  id: string
  labels: string[]
  properties: { [key: string]: any }
  x: number
  y: number
  fx?: number | null
  fy?: number | null
  icon?: string
}

export interface Relationship {
  id: string
  type: string
  startNode: string
  endNode: string
  source?: Node
  target?: Node
  properties: { [key: string]: any }
  linknum?: number
}
